<div class="d-flex flex-column align-items-center">
    <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[700px]">
      <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span></div>
      <h5>Change Examination Schedule Status</h5>
      <div class="form-group">
        <label for="status" >Status</label>
            <ng-select class="form-select" id="status" (change)="onChange($event)" [(ngModel)]="selectedStatus" [ngModelOptions]="{ standalone: true }">
                <ng-option value="" disabled selected>Select Exam Status</ng-option>
                <ng-option *ngFor="let status of examStatuses" [value]="status">{{status}}</ng-option>
            </ng-select>
      </div>      
      <div class="d-flex justify-content-between mt-4">
        <input class="btn btn-primary" type="button" value="YES" (click)="yesClicked()"/>
        <input class="btn btn-danger" type="button" value="CANCEL" (click)="noClicked()"/>
      </div>      
    </div>
</div>